module.exports = __webpack_public_path__ + "img/As.978bea02.png";